export const defaultContext = {
    hasRight: () => null,
    user: undefined,
}
